<template>
    <div class="lm-order-form__comment">
        <div class="lm-order-form__title">
            Комментарий
        </div>
        <div class="lm-order-form__comment-field">
            <combo-input
                class="lm-order-fields__group"
                v-model="comment"
                label="Удобное время доставки, контакт для связи и другие нюансы"
                :options="getComments"
                is-textarea />
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ComboInput from '../../common/ComboInput.vue';

export default {
    name: 'OrderComment',
    components: {ComboInput},
    data: () => ({
        comment: '',
    }),
    computed: {
        ...mapGetters('market', [
            'filteredContacts',
        ]),
        getComments() {
            if (this.filteredContacts && this.filteredContacts.comments) {
                return this.filteredContacts.comments;
            }
            return [];
        },
    },
    watch: {
        comment(value) {
            this.$emit('update:comment', value);
        },
    },
};
</script>
